angular.module('jv.Common.TextUtil', [])
    .service('App', [function(){
        this.param = function(obj, traditional) {
            traditional = traditional || true;
            var clone = angular.extend({}, obj);
            angular.forEach(clone, function(value, key){
                if (angular.isUndefined(value) || value === null || value === '') {
                    delete clone[key];
                }
            });
            return $.param(clone, traditional);
        };
    }])
    .service('TextUtil', [function() {
        this.makeNameUnique = function(name, copyText) {
            var newName,
            copySearch = new RegExp('\\(('+copyText+' ?)(\\d*)\\)');
            // find report names with (Copy[ num]) in the name and add or increment num
            newName = name.replace(copySearch, function(match, text, num) {
                if (num) {
                    num = Number(num) + 1;
                }
                else {
                    num = ' 2';
                }
                return '(' + text + num + ')';
            });
            //if no match is found, add (Copy)
            if (newName === name) {
                newName += ' ('+ copyText +')';
            }
            return newName;
        };

        this.htmlEncode = function(value){
            return angular.isDefined(value) ? $('<div/>').text(value).html() : value;
        };

        this.htmlDecode = function(value){
            return angular.isDefined(value) ? $('<div/>').html(value).text() : value;
        };

        this.isNotNullOrUndefined = function(value){
            return angular.isDefined(value) && value !== null;
        };

        /**
         *
         * @param {Array<Object>} field values
         * @returns field values with decoded values
         * @example
         * ```
         * TextUtil.decodeFieldValuesList([{ key: 'a &amp; b', value: 'a &amp; b' }]);
         * @returns [{ key: 'a & b', value: 'a & b' }]
         * ```
         */
        this.decodeFieldValuesList = function(fieldValues = []) {
            return fieldValues.map(val => ({
                       ...val,
                       key: this.htmlDecode(val.key),
                       value: this.htmlDecode(val.value)
                  }));
        };

        /**
         *
         * @param {Array<Object>} fields Custom list of fields
         * @returns Custom list of fields with parsed HTML property values
         * @example
         * ```
         * TextUtil.getParsedCustomFieldHtmlProperties([{ name: 'Text &lt;', values: [{ key: '&gt;', value: '&gt;' }] }]);
         * @returns [{ name: 'Text <', values: [{ key: '>', value: '&gt;' }] }]
         * ```
         */
        this.getParsedCustomFieldHtmlProperties = function(fields = []) {
            return fields.map(field => ({
                ...field,
                name: this.htmlDecode(field.name),
                values: (field.values || []).map(value => ({
                    ...value,
                    key: this.htmlDecode(value.key)
                }))
            }));
        };
    }]);